import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export default function RegisterPage() {
  const { register } = useAuth();
  const navigate     = useNavigate();
  const [form, setForm] = useState({ first_name: '', last_name: '', email: '', password: '' });
  const [loading, setLoading] = useState(false);
  const handleSubmit = async e => {
    e.preventDefault();
    setLoading(true);
    try { await register(form); toast.success('Account created! 🥻'); navigate('/'); }
    catch (err) { toast.error(err.message); }
    finally { setLoading(false); }
  };
  return (
    <div className="page" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '80vh', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 440, background: '#fff', border: '1px solid var(--border)', padding: '48px 40px' }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <div style={{ fontSize: 40 }}>🥻</div>
          <h1 style={{ fontFamily: "'Playfair Display',serif", fontSize: 28, color: '#7c3aed', fontStyle: 'italic', marginTop: 8 }}>Create Account</h1>
          <Link to="/login/otp" className="auth-inline-cta">Prefer Mobile OTP? Start here</Link>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="register-name-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            <div className="form-group"><label className="form-label">First Name</label><input className="form-input" value={form.first_name} onChange={e => setForm(f => ({ ...f, first_name: e.target.value }))} required placeholder="First name"/></div>
            <div className="form-group"><label className="form-label">Last Name</label><input className="form-input" value={form.last_name} onChange={e => setForm(f => ({ ...f, last_name: e.target.value }))} placeholder="Last name"/></div>
          </div>
          <div className="form-group"><label className="form-label">Email</label><input className="form-input" type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required placeholder="your@email.com"/></div>
          <div className="form-group"><label className="form-label">Password (min 6 chars)</label><input className="form-input" type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} required minLength={6} placeholder="••••••••"/></div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', justifyContent: 'center', padding: '14px', marginTop: 8 }} disabled={loading}>{loading ? 'Creating...' : 'Create Account'}</button>
        </form>
        <div className="auth-divider"><span>or</span></div>
        <Link to="/login/otp" className="btn btn-outline auth-otp-btn">Login with Mobile OTP</Link>
        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 14, color: '#64748b' }}>
          Already have an account? <Link to="/login" style={{ color: '#7c3aed', fontWeight: 600 }}>Login</Link>
        </div>
      </div>
    </div>
  );
}
